
export let configData: any = {};

configData.customisationId = '';

configData.baseUrl = 'http://localhost/Jassu/designer';
configData.actionQueryString = '?ACT=41';

configData.fonts = [
    {name : "CollegiateFLF", fontName : "CollegiateFLF", direction : "ltr"},
    {name : "Arial Narrow", fontName : "Arial Narrow", direction : "ltr"},
    {name : "Krinkes Regular PERSONAL USE", fontName : "Krinkes Regular PERSONAL USE", direction : "ltr"},
    {name : "Bulletto Killa", fontName : "Bulletto Killa", direction : "ltr"},
    {name : "CollegiateBorderFLF", fontName : "CollegiateBorderFLF", direction : "ltr"},
    {name : "Athletic", fontName : "Athletic", direction : "ltr"},
    {name : "CollegiateBlackFLF", fontName : "CollegiateBlackFLF", direction : "ltr"},
    {name : "TKD HomeRun Script", fontName : "TKD HomeRun Script", direction : "ltr"},
    {name : "CollegiateOutlineFLF", fontName : "CollegiateOutlineFLF", direction : "ltr"},
    {name : "SignPainter HouseScript", fontName : "SignPainter HouseScript", direction : "ltr"},
    {name : "Amarillo", fontName : "Amarillo", direction : "ltr"},
    {name : "Aktuelle", fontName : "Aktuelle", direction : "ltr"},
    {name : "CollegiateInsideFLF", fontName : "CollegiateInsideFLF", direction : "ltr"},
    {name : "Arial", fontName : "Arial", direction : "ltr"},
    {name : "Montserrat", fontName : "Montserrat", direction : "ltr"},
    {name : "Typewriter-Serial", fontName : "Typewriter-Serial", direction : "ltr"},
    {name : "College", fontName : "College", direction : "ltr"},
    {name : "Brannboll F PERSONAL USE ONLY", fontName : "Brannboll F PERSONAL USE ONLY", direction : "ltr"},
    {name : "Superstar M54", fontName : "Superstar M54", direction : "ltr"},
    {name : "Arial Rounded MT", fontName : "Arial Rounded MT", direction : "ltr"},
    {name : "Montserrat", fontName : "Montserrat", direction : "ltr"},
    {name : "Arial Black", fontName : "Arial Black", direction : "ltr"},
    {name : "Varsity", fontName : "Varsity", direction : "ltr"},
    {name : "United Sans SmCd Bd", fontName : "United Sans SmCd Bd", direction : "ltr"},
    {name : "United Serif SmCd Hv", fontName : "United Serif SmCd Hv", direction : "ltr"},
    {name : "United Serif SmCd Bd", fontName : "United Serif SmCd Bd", direction : "ltr"},

    {name : "نزار كوكون كورديش", fontName : "Nizar Cocon Kurdish", direction : "rtl"},
    {name : "فيرداوس زد عادي", fontName : "Ferdaos Zd Normal", direction : "rtl"},
    {name : "ب شمس", fontName : "B Shams", direction : "rtl"},
    {name : "كاست فارسي", fontName : "KacstFarsi", direction : "rtl"},
    {name : "السادة", fontName : "Sada", direction : "rtl"},
    {name : "فانتيزي", fontName : "B Fantezy", direction : "rtl"},
    {name : "الروبوت العربية نسخ", fontName : "Droid Arabic Naskh", direction : "rtl"},
    {name : "هسن السادية" ,nameEnglish : "HSN sadiyah", direction : "rtl"},
    {name : "هسن ابتسام", fontName : "HSN Ibtisam", direction : "rtl"},
    {name : "ريخا", fontName : "Reqaa", direction : "rtl"},
    {name : "بيغفيستا العربية بيتا", fontName : "BigVesta Arabic Beta", direction : "rtl"},
    {name : "رسالة الديواني", fontName : "Diwani Letter", direction : "rtl"},
    {name : "سردار حور", fontName : "A Sardar Hoor", direction : "rtl"}
];


configData.colorPalette = [];
configData.imagePath = 'assets/images/';

configData.patchImages = ['patch-image1.png', 'patch-image2.png', 'patch-image3.png', 'patch-image4.png', 'patch-image5.png']
configData.clipartImages = ['clipart-image1.png', 'clipart-image2.png', 'clipart-image3.png', 'clipart-image4.png', 'clipart-image5.png', 'clipart-image6.png', 'clipart-image7.png']

configData.customisationDefaults = {
    // left_base_path: 'assets/images/garments/left.svg',
    // front_base_path: 'assets/images/garments/jacket_front.svg',
    // back_base_path: 'assets/images/garments/jacket_back.svg',

    designPlaces : [
        {
            name : 'basic',
            fullName : 'Main Colors',
            active : true
        },
        {
            name : 'front',
            fullName : 'Front View'
        },
        {
            name : 'back',
            fullName : 'Back View'
        },
        {
            name : 'left',
            fullName : 'Left View'
        },
        {
            name : 'right',
            fullName : 'Right View'
        },
        {
            name : 'inner',
            fullName : 'Inner View'
        }
    ],

    basic: [{
            label: 'Body',
            designOptions: [{ name: 'color' }],
            selector: '.jacket-body',
            side: 'Both sides',
            color: '#C51F47',
        },

        {
            label: 'Sleeves',
            designOptions: [{ name: 'color' }],
            selector: '.jacket-sleeves',
            side: 'Both sides',
            color: '#FFFFFF',
        },

        {
            label: 'Rib 1',
            designOptions: [{ name: 'color' }],
            selector: '.jacket-rib-1',
            side: 'Both sides',
            color: '#C51F47',
        },

        {
            label: 'Rib 2',
            designOptions: [{ name: 'color' }],
            selector: '.jacket-rib-2',
            side: 'Both sides',
            color: '#FFFFFF',
        },
        {
            label: 'Pockets',
            designOptions: [{ name: 'color' }],
            selector: '.jacket-pocket',
            side: 'Front',
            color: '#FFFFFF',
        },
        {
            label: 'Buttons',
            designOptions: [{ name: 'color' }],
            selector: '.jacket-buttons',
            side: 'Front',
            color: '#FFFFFF',
        },

    ],
    front: [

        {
            label: 'Front Top Left',
            designOptions: [
                
                { name: 'Artwork' },
                { name: 'Upload Image' },
                { name: 'Text' }
            ],
            selector: '.front-top-right',
            side: 'Front',
            selectedStyle: {
                svg: {
                    height: 100.27,
                    width: 93.73,
                    viewBox: "0 0 256 256",
                    x: 325,
                    y: 185
                },
                image: {
                    // 'xlink:href': 'assets/images/patch-image1.png',
                    height: 256,
                    width: 256,
                    x: 0,
                    y: 0,
                },
                text : {
                    font : {name : "CollegiateFLF", fontName : "CollegiateFLF", direction : "ltr"},
                    fill : '#000',
                    fontSize : 40,
                    text : '',
                    x: 380,
                    y: 220,
                    maxLength : 25,
                    'text-anchor' : 'middle',
                    'stroke-width': 0,'stroke': "#000000",
                    noStroke : true
                }
            }
        },

        {
            label: 'Front Top Right',
            designOptions: [
                
                { name: 'Artwork' },
                { name: 'Upload Image' },
                { name: 'Text' }
            ],
            selector: '.front-top-left',
            side: 'Front',
            selectedStyle: {
                svg: {
                    height: 100.27,
                    width: 93.73,
                    viewBox: "0 0 256 256",
                    x: 184,
                    y: 185
                },
                image: {
                    // 'xlink:href': 'assets/images/patch-image1.png',
                    height: 256,
                    width: 256,
                    x: 0,
                    y: 0
                },
                text : {
                    font : {name : "CollegiateFLF", fontName : "CollegiateFLF", direction : "ltr"},
                    fill : '#000',
                    fontSize : 40,
                    text : '',
                    x: 200,
                    y: 220,
                    maxLength : 25,
                    'text-anchor' : 'middle',
                    'stroke-width': 0,'stroke': "#000000",
                    noStroke : true
                }
            }
        }

    ],
    back: [
        {
            label: 'Back Center',
            designOptions: [
                
                { name: 'Artwork' },
                { name: 'Upload Image'}
            ],
            selector: '.back-center',
            side: 'Back',

            selectedStyle: {
                svg: {
                    height: 206.39,
                    width: 228.27,
                    viewBox: "0 0 256 256",
                    x: 182.49,
                    y: 157.99
                },
                image: {
                    // 'xlink:href': 'assets/images/patch-image1.png',
                    height: 256,
                    width: 256,
                    x: 0,
                    y: 0
                },
            }
        },
        {
            label: 'Back Top',
            designOptions: [
                { name: 'Text' }
            ],
            selector: '.back-top',
            side: 'Back',

            selectedStyle: {
                type : 'text',
                text : {
                    font : {name : "CollegiateFLF", fontName : "CollegiateFLF", direction : "ltr"},
                    fill : '#000',
                    fontSize : 40,
                    text : '',
                    x: 290,
                    y: 165,
                    'text-anchor' : 'middle',
                    'stroke-width': 0,'stroke': "#000000"
                }
            }
        },

        {
            label: 'Back Bottom',
            designOptions: [
                { name: 'Text' }
            ],
            selector: '.back-bottom',
            side: 'Back',
            selectedStyle: {
                type : 'text',
                text : {
                    font : {name : "CollegiateFLF", fontName : "CollegiateFLF", direction : "ltr"},
                    fill : '#000',
                    fontSize : 40,
                    x: 290,
                    y: 435,
                    text : '',
                    'text-anchor' : 'middle',
                    'stroke-width': 0,'stroke': "#000000"
                    
                }
            }
        },

    ],
    left : [
        {
            label: 'Left Design',
            designOptions: [
                
                { name: 'Artwork' },
                { name: 'Upload Image' },
                { name: 'Text' }
            ],
            selector: '.left-design',
            side: 'left',

            selectedStyle: {
                svg: {},
                image: {
                    // 'xlink:href': 'assets/images/patch-image1.png',
                    height: 256,
                    width: 256,
                    x: 0,
                    y: 0
                },
                text : {
                    font : {name : "CollegiateFLF", fontName : "CollegiateFLF", direction : "ltr"},
                    fill : '#000',
                    fontSize : 40,
                    maxLength : 2,
                    text : '',
                    x: 185,
                    y: 215,
                    'text-anchor' : 'middle',
                    'stroke-width': 0,'stroke': "#000000"
                    
                }
            }
        },
    ],
    right : [
        {
            label: 'Right Design',
            designOptions: [
                
                { name: 'Artwork' },
                { name: 'Upload Image' },
                { name: 'Text' }
            ],
            selector: '.right-design',
            side: 'right',

            selectedStyle: {
                svg: {},
                image: {
                    // 'xlink:href': 'assets/images/patch-image1.png',
                    height: 256,
                    width: 256,
                    x: 0,
                    y: 0
                },
                text : {
                    font : {name : "CollegiateFLF", fontName : "CollegiateFLF", direction : "ltr"},
                    fill : '#000',
                    fontSize : 40,
                    maxLength : 2,
                    text : '',
                    x: 50,
                    y: 215,
                    'text-anchor' : 'middle',
                    'stroke-width': 0,'stroke': "#000000"
                    
                }
            }
        },
    ],
    inner : [
        {
            label: 'Inner Design',
            designOptions: [
                { name: 'Inner' }
            ],
            selector: '.inner-design',
            side: 'inner',
            innerDesignSelected : false,
            patchSelector : ['inner-badge-color-3', 'inner-badge-color-1'],
            innerDesignSelectedColor : ""
        },
    ],
    helpersBack: [{
            selector: '.custom_pin_sleeves',
            target: '.jacket-sleeves',
            x: 120.21,
            y: 207.94
        }, {
            selector: '.custom_pin_rib_1',
            target: '.jacket-rib-1',
            x: 46.28,
            y: 450
        }, {
            selector: '.custom_pin_rib_2',
            target: '.jacket-rib-2',
            x: 202.36,
            y: 470.11
        }, {
            selector: '.custom_pin_body',
            target: '.jacket-body',
            x: 207.29,
            y: 153.72
        }, {
            selector: '.custom_pin_rib_3',
            target: '.jacket-rib-3',
            x: 547.4,
            y: 460.54
        }
    ],
    helpers: [{
            selector: '.custom_pin_sleeves',
            target: '.jacket-sleeves',
            x: 120.21,
            y: 207.94
        }, {
            selector: '.custom_pin_rib_1',
            target: '.jacket-rib-1',
            x: 46.28,
            y: 450
        }, {
            selector: '.custom_pin_rib_2',
            target: '.jacket-rib-2',
            x: 202.36,
            y: 470.11
        }, {
            selector: '.custom_pin_buttons',
            target: '.jacket-buttons',
            x: 285,
            y: 370
        }, {
            selector: '.custom_pin_pockets',
            target: '.jacket-pocket',
            x: 399.52,
            y: 355.81
        }, {
            selector: '.custom_pin_body',
            target: '.jacket-body',
            x: 207.29,
            y: 153.72
        }, {
            selector: '.custom_pin_rib_3',
            target: '.jacket-rib-3',
            x: 547.4,
            y: 460.54
        }
    ],
    form: [{
        name: '',
        email: '',
        mobile: '',
        state: '',
        company: '',
        order: '',
        contact: '',
        url: '',
        site: ''
    }],
    styles: [

    ]
};


// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/config.ts